<template>
  <div class="container">
    <!-- 癌种 -->
    <!-- <cards_table
      :headName="headCancer"
      :headView="headView"
      :titleData="titleCanner"
      :tableData="cancerData"
      @aiYangben="aiYangben"
      @ai="ai"
      :color1="'#2F354D'"
      :color2="'#4B84FF'"
    ></cards_table> -->
    <!-- 性别分布 -->
    <div class="cards-sex" id="cards-box">
      <div class="cards-title">
        <span>{{ genderdistribution }}</span>
      </div>
      <div class="cards-shaw"></div>
      <div class="drawPadding">
        <!-- <div class="loadbox">
          <van-loading type="spinner" color="#1989fa" />
        </div> -->
        <Empty v-if="sexData.length < 0" />
        <FszPie v-else :data="sexDataPie" height="281px"></FszPie>
      </div>
    </div>
    <!-- 人群基因突变频率 -->
    <cards_table
      :headName="headName"
      :headView="headView"
      :titleData="titleData"
      :tableData="tableData"
      @geneClick="geneClick"
      @clickYangben="clickYangben"
      @cancerSpecies="cancerSpecies"
      @ceiliingAnalysis="ceiliingAnalysis"
      :flag="true"
      :color1="'#4B84FF'"
      :color2="'#4B84FF'"
    ></cards_table>
    <!-- 年龄分布 -->
    <div class="cards-age">
      <div class="cards-title">
        <span>{{ agedistribution }}</span>
      </div>
      <div class="cards-shaw"></div>
      <Empty v-if="dataBar == ''" />

      <FszBar v-else :data="dataBar" height="281px"></FszBar>
    </div>
    <!-- 报药比例 -->
    <!-- <div class="cards-age">
      <div class="cards-title">
        <span>{{ drugreportingratio }}</span>
      </div>
      <div class="cards-shaw"></div>
      <FszPie :data="dataPie" height="281px"></FszPie>
    </div> -->

    <!-- 产品类型 -->
    <cards_table
      :headName="headProduct"
      :headView="headView"
      :titleData="titleProduct"
      :tableData="productData"
      @cpYangben="cpYangben"
      @cpCalss="cpCalss"
      :color1="'#2F354D'"
      :color2="'#4B84FF'"
    ></cards_table>
  </div>
</template>

<script>
import isiOS from "../../utils/iosAn";
// import F2 from "@antv/f2/lib/index-all";
import { Toast } from "vant";
import { dataStat, genData } from "@/api/dataStatistics.js";
import * as echarts from "echarts";
import cards_table from "./compontents/tableList";
export default {
  components: {
    cards_table,
  },
  data() {
    return {
      id: 12336666,
      // 折线图
      // dataLine: {
      //     chartLineData: [
      //         {
      //             name: "折线1",
      //             color: "#6395F9",
      //             data: []
      //         },
      //         {
      //             name: "折线2",
      //             color: "#62DAAB",
      //             data: []
      //         }
      //     ],
      //     chartLineAxis: []
      // },
      // 柱状
      dataBar: {
        chartBarData: [
          {
            // name: "产出医院数量",
            // color: "#6395F9",
            data: [],
          },
          // {
          //     name: "产出医生数量",
          //     color: "#62DAAB",
          //     data: []
          // },
          // {
          //     name: "产出科室数量",
          //     color: "#F6C022",
          //     data: []
          // }
        ],
        chartBarAxis: [],
      },
      // 饼图
      dataPie: {
        chartPieData: [
          {
            name: "报药比例",
            color: "#3186FF",
            data: [],
          },
        ],
      },
      sexDataPie: {
        chartPieData: [
          {
            name: "性别分布",
            color: "#3186FF",
            data: [],
            title: {},
          },
        ],
      },
      sexData: [],
      samplenum: null,
      genderdistribution: "性别分布",
      agedistribution: "年龄分布",
      drugreportingratio: "报药比例",
      headName: "人群基因突变频率",
      headView: "查看全部",
      headCancer: "癌种",
      headProduct: "产品类型",
      titleCanner: [
        {
          name: "名称",
          samplenum: "突变样本数",
          percentage: "占比(%)",
        },
      ],
      titleProduct: [
        {
          name: "名称",
          samplenum: "突变样本数",
          percentage: "占比(%)",
        },
      ],
      titleData: [
        {
          name: "Gene",
          samplenum: "突变样本数",
          percentage: "占比(%)",
        },
      ],
      tableData: [],
      cancerData: [],
      productData: [],
    };
  },
  methods: {
    /**获取年龄分布接口 */
    async getAge(cancer, cancerOne) {
      try {
        let { data } = await dataStat({
          sampleTag: "age",
          cancerOneList: cancerOne,
          cancerTwoList: cancer,
        });
        console.log(data.cancerOneList);
        data.cancerOneList.forEach((item) => {
          this.dataBar.chartBarAxis.push(item.ageProportion);
          this.dataBar.chartBarData[0].data.push(item.ageCount);
        });
      } catch (err) {}
    },
    /**获取产品类型接口 */
    async getProductClass(cancer, cancerOne) {
      try {
        let { data } = await dataStat({
          pageCurrent: 0,
          pageSize: 7,
          sampleTag: "productLine",
          cancerOneList: cancerOne,
          cancerTwoList: cancer,
        });
        this.productData = data.product.map((item) => {
          return {
            name: item.productName,
            samplenum: item.sampleCount,
            percentage: item.genePercent,
          };
        });
      } catch (err) {}
    },
    /**获取癌种数据接口 */
    async getCancer() {
      try {
        let { data } = await dataStat({
          pageCurrent: 0,
          pageSize: 7,
          sampleTag: "cancer",
        });
        this.cancerData = data.cancer.map((item) => {
          return {
            name: item.cancerTwo,
            samplenum: item.sampleCount,
            percentage: item.genePercent,
          };
        });
      } catch (err) {}
    },
    /**获取基因数据接口 */
    async getGenedata(cancer, cancerOne) {
      try {
        let { data } = await genData({
          pageCurrent: 0,
          pageSize: 7,
          cancerOneList: cancerOne,
          cancerTwoList: cancer,
        });
        this.tableData = data.map((item) => {
          return {
            name: item.geneName,
            samplenum: item.geneCount,
            percentage: item.genePercent,
          };
        });
      } catch (error) {}
    },
    /**获取报药比例数据接口 */
    async getBydata() {
      try {
        let { data } = await dataStat({
          sampleTag: "sex",
        });
        this.sexData = data.sex;
        console.log(this.sexData);
        let sexmap = { 1: "男性", 0: "女性", 2: "未知" };
        let sortmap = { 男性: 0, 女性: 1, 未知: 2 };
        this.dataPie.chartPieData[0].data = [
          { value: data.sex[0].sexCount, name: sexmap[data.sex[0].sex] },
          { value: data.sex[1].sexCount, name: sexmap[data.sex[1].sex] },
          { value: data.sex[2].sexCount, name: sexmap[data.sex[2].sex] },
        ].sort((a, b) => {
          return sortmap[a.name] - sortmap[b.name];
        });
        let subtext =
          data.sex[0].sexCount + data.sex[1].sexCount + data.sex[2].sexCount;
        console.log(subtext);

        this.dataPie.chartPieData[0].title = {
          text: "样本",
          textStyle: {
            color: "#9095A7",
            fontSize: 12,
            fontWeight: 400,
            padding: [-20, 0, 0, 0],
          },
          subtext: subtext,
          subtextStyle: {
            color: "#2F354D",
            fontSize: 26,
            fontWeight: 600,
          },
          // itemGap: 10, // 主副标题距离

          left: "center",
          top: 70,
        };
      } catch (err) {}
    },
    /**获取性别数据接口 */
    async getGender(cancer, cancerOne) {
      try {
        let { data } = await dataStat({
          sampleTag: "sex",
          cancerOneList: cancerOne,
          cancerTwoList: cancer,
        });
        this.sexData = data.sex;
        console.log(this.sexData, "21312312312312");
        console.log(this.sexData.length, "21312312312312");
        this.sexDataPie.chartPieData[0].data = [
          { value: data.sex[0].sexCount, name: data.sex[0].sex+'性' },
          { value: data.sex[1].sexCount, name: data.sex[1].sex+'性' },
          { value: data.sex[2].sexCount, name: data.sex[2].sex },
        ]
        let subtext =
          data.sex[0].sexCount + data.sex[1].sexCount + data.sex[2].sexCount;
        console.log(subtext);

        this.sexDataPie.chartPieData[0].title = {
          text: "样本",
          textStyle: {
            color: "#9095A7",
            fontSize: 12,
            fontWeight: 400,
            padding: [-20, 0, 0, 0],
          },
          subtext: subtext,
          subtextStyle: {
            color: "#2F354D",
            fontSize: 26,
            fontWeight: 600,
          },
          // itemGap: 10, // 主副标题距离

          left: "center",
          top: 70,
        };
      } catch (err) {}
    },
    ceiliingAnalysis(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(type);
      } else {
        window.android.JSCallNative(JSON.stringify(type));
      }
    },
    // 癌种-点击样本数
    aiYangben(param) {
      console.log(param, 2121212);
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },

    // 癌种-查看全部
    ai(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(type);
      } else {
        window.android.JSCallNative(JSON.stringify(type));
      }
    },
    // 产品类型-点击样本数
    cpYangben(param) {
      console.log(param, 2121212);
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 产品类型-查看全部
    cpCalss(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(type);
      } else {
        window.android.JSCallNative(JSON.stringify(type));
      }
    },
    // 人群基因突变-点击gene
    geneClick(param) {
      console.log(param);
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 人群基因突变-点击样本数
    clickYangben(param) {
      console.log(param, 2121212);
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 人群基因突变-查看全部
    cancerSpecies(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(type);
      } else {
        window.android.JSCallNative(JSON.stringify(type));
      }
      console.log(arg);
      // this.$router.push({
      //   name: "mutationfrequency",
      //   params: {},
      // });
    },
    initLineChartData() {
      //   this.dataLine.chartLineData.forEach(element => {
      //     element.data = [];
      //   });
      this.dataBar.chartBarData.forEach((element) => {
        element.data = [];
      });
      this.dataPie.chartPieData.forEach((element) => {
        element.data = [];
      });
      this.sexDataPie.chartPieData.forEach((element) => {
        element.data = [];
      });
      setTimeout(() => {
        // this.dataLine.chartLineData[0].data.push(
        //   120,
        //   132,
        //   101,
        //   134,
        //   90,
        //   230,
        //   210
        // );
        // this.dataLine.chartLineData[1].data.push(
        //   108,
        //   125,
        //   148,
        //   136,
        //   99,
        //   87,
        //   148
        // );
        // this.dataLine.chartLineAxis.push(
        //   "01/01",
        //   "01/02",
        //   "01/03",
        //   "01/04",
        //   "01/05",
        //   "01/06",
        //   "01/07"
        // );
        // 柱状图
        // this.dataBar.chartBarData[1].data.push(
        //     6,
        //     7,
        //     9,
        //     8,
        //     8,
        //     9,
        //     11,
        //     9,
        //     7,
        //     5,
        //     9,
        // );
        // this.dataBar.chartBarData[2].data.push(
        //     6,
        //     18,
        //     15,
        //     19,
        //     13,
        //     13,
        //     15,
        //     3,
        //     6,
        //     8,
        //     18,
        // );
        // 饼图
      }, 1000);

      // 调接口
      // consultTreeData(this.param).then(res => {
      //   // 清空数据
      //   this.data.chartLineData.forEach(element => {
      //     element.data = [];
      //   });
      //   this.data.chartLineAxis = []
      //   res.param.forEach(element => {
      //     this.data.chartLineData[0].data.push(element.wzCount);
      //     this.data.chartLineData[1].data.push(element.fzCount);
      //     this.data.chartLineAxis.push(this.formatYearMonth(element.dateTime));
      //   });
      // });
    },

    columnar() {
      const data = [
        {
          year: "18-30",
          sales: 2751,
        },
        {
          year: "30-35",
          sales: 8912,
        },
        {
          year: "45-55",
          sales: 14572,
        },
        {
          year: "55-65",
          sales: 22077,
        },
        {
          year: "65-75",
          sales: 17992,
        },
        {
          year: ">75",
          sales: 15951,
        },
      ];
      const chart = new F2.Chart({
        id: "chartage",
        pixelRatio: window.devicePixelRatio,
        width: document.getElementById("cards-box").offsetWidth,
        height: document.getElementById("chartbox1").offsetHeight,
      });
      chart.source(data, {
        sales: {
          tickCount: 5,
        },
      });
      chart.tooltip({
        showItemMarker: false,
        onShow: function onShow(ev) {
          const items = ev.items;
          items[0].name = null;
          items[0].name = items[0].title;
          items[0].value = "¥ " + items[0].value;
        },
      });
      chart.legend({
        nameStyle: {
          fontSize: 13,
        },
      });
      chart
        .interval()
        .position("year*sales")
        .color("l(90) 0:#4B84FF 1:#52E4C9"); // 定义柱状图渐变色
      chart.render();
    },
    funTest() {
      var _this = this;
      var lineWidth = document.getElementById("twChart");
      lineWidth.style.width = window.innerWidth - 24 + "px";
      this.chart = echarts.init(lineWidth);
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("twChart"));
      // var chartDom = document.getElementById('twChart');
      // var myChart = echarts.init(chartDom);
      // window.onresize = myChart.resize;
      // let myChart = this.$echarts.init(document.getElementById('twChart'))
      // let listener = function () {
      //     myChat.resize()
      // }
      // window.addEventListener('resize', listener)

      var option = {
        color: ["#4B84FF", "#27CA8D", "#626C91"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "0%",
          left: "center",
          itemHeight: 6,
          itemWidth: 6,
          itemGap: 70,
          icon: "circle",
        },
        title: {
          text: "样本",
          textStyle: {
            color: "#9095A7",
            fontSize: 12,
            fontWeight: 400,
            padding: [-20, 0, 0, 0],
          },
          subtext: "21323",
          subtextStyle: {
            color: "#2F354D",
            fontSize: 26,
            fontWeight: 600,
          },
          // itemGap: 10, // 主副标题距离

          left: "center",
          top: 90,
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["55%", "70%"],
            avoidLabelOverlap: false,

            label: {
              //展示文本设置
              normal: {
                show: true, //展示
                position: "outside", // outside表示文本显示位置为外部
              },
              emphasis: {
                //文本样式
                show: true, //展示
                textStyle: {
                  //文本样式
                  fontSize: "14",
                  fontWeight: "600",
                },
              },
            },
            labelLine: {
              //引导线设置
              normal: {
                show: false, //引导线显示
              },
            },
            data: [
              { value: 50, name: "男性" },
              { value: 48, name: "女性" },
              { value: 2, name: "未知" },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
  created() {
    this.initLineChartData();
  },
  mounted() {
    // this.getBydata();
    // this.getAge();
    // this.getProductClass();
    // this.getCancer();
    // this.getGenedata();
    // this.getGender();
  },
  beforeRouteEnter(to, from, next) {
    // ...
    window.NativeCallJS = (res) => {
      var par = JSON.parse(res);
      console.log(par, "parpar");
      next((vm) => {
        vm.getAge(par.cancer, par.cancerOne);
        vm.getProductClass(par.cancer, par.cancerOne);
        vm.getGenedata(par.cancer, par.cancerOne);
        vm.getGender(par.cancer, par.cancerOne);
      });
    };
  },
};
</script>
<style lang="less" scoped>
.loadbox {
  background: rgba(255, 255, 255, 0.2);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.drawPadding {
  padding-left: 24px;
  padding-right: 24px;
  position: relative;
}

.chartsexNum > span {
  /* width: 33.3%; */
  /* text-align: right; */
  margin-left: 58px;
  display: inline-block;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2f354d;
  line-height: 22px;
}

/* 性别分布 */
.cards-sex {
  width: 343px;
  height: auto;
  background: @background_color;
  border-radius: 10px;
  margin: 0 auto;
}

.cards-title {
  height: 70px;
}

.cards-title > span:nth-of-type(1) {
  display: inline-block;
  font-size: 18px;
  font-family: @family;
  font-weight: 500;
  color: #2f354d;
  padding-left: 24px;
  line-height: 70px;
}

.cards-title > span:nth-of-type(2) {
  font-size: 12px;
  font-family: @family;
  font-weight: 400;
  color: #4b84ff;
  /* float: right; */
  margin-right: 3px;
  line-height: 70px;
}

.cards-shaw {
  display: inline-block;
  width: 343px;
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(52, 68, 132, 0) 0%,
    rgba(52, 68, 132, 0.1) 100%
  );
}

.smple {
  color: red !important;
  font-size: 26px;
}

/* 年龄分布 */
.cards-age {
  width: 343px;
  height: auto;
  background: @background_color;

  border-radius: 10px;
  margin: 0 auto;
  margin-top: 20px;
}

/* 报药比例 */
.cards-drug {
  width: 343px;
  height: auto;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 20px;
}
</style>
